import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { t3, pick3 } from "../i18n/v3";
import { PageShell, PageHeader } from "../components/PageShell";
import BeamProgress from "../components/BeamProgress";
import PageBackdrop from "../components/PageBackdrop";

const ease = [0.16, 1, 0.3, 1];

export default function PhilosophyPage() {
    const { lang } = useLanguage();
    const sections = pick3(t3.philosophy.sections, lang);
    return (
        <PageShell testId="page-philosophy" backdrop={<PageBackdrop variant="philosophy" />}>
            <BeamProgress />
            <PageHeader
                overline={pick3(t3.philosophy.overline, lang)}
                title={pick3(t3.philosophy.title, lang)}
                kicker={pick3(t3.philosophy.lede, lang)}
            />

            <section className="mt-6 border-t border-[color:var(--line-strong)]">
                {sections.map((s, i) => (
                    <motion.article
                        key={i}
                        initial={{ opacity: 0, y: 14 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-8%" }}
                        transition={{ duration: 0.75, ease, delay: (i % 4) * 0.06 }}
                        className="grid grid-cols-12 gap-6 py-10 md:py-12 border-b border-[color:var(--line)]"
                    >
                        <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-[0.28em] uppercase text-[color:var(--warm-gray-2)]">
                            {String(i + 1).padStart(2, "0")} · {s.k}
                        </div>
                        <div className="col-span-12 md:col-span-10">
                            <h3 className="font-display text-[26px] md:text-[36px] leading-[1.1] tracking-[-0.005em] text-[color:var(--navy)]">
                                {s.t}
                            </h3>
                            <p className="mt-4 max-w-[60ch] text-[16px] md:text-[17px] leading-[1.7] text-[color:var(--navy)]/85">
                                {s.d}
                            </p>
                        </div>
                    </motion.article>
                ))}
            </section>
        </PageShell>
    );
}
